<div style="height: 35px; background: #003b30;">
    <div class="d-flex justify-content-end">
        <div class="p-2 bd-highlight">
            <a href="https://bit.ly/matricula-online-st" style=" color: #fff;" class="">
                <img src="./assets/images/icon/footer-icon-phone.svg" alt="">+562 2297 7278
            </a>
        </div>
        <div class="p-2 bd-highlight">
            <a href="https://www.tupuedes.cl/matricula-online/preguntas-frecuentes/" style=" color: #fff;" class="ml-1 ">
                <img src="./assets/images/icon/footer-icon-chat.svg" alt=""> Preguntas Frecuentes
            </a>
        </div>
        <div class="p-2 bd-highlight">
            <a href="https://www.tupuedes.cl/contacto/" style=" color: #fff;" class="ml-1">
                <img src="./assets/images/icon/footer-icon-mail.svg" alt=""> Formulario de Contacto
            </a>
        </div>
    </div>


</div>
<form id="lgform" [formGroup]="LoginForm" novalidate>
    <div style="background-color:#eee; height:900px">
        <div class="row mt-4" style="background: white;">
            <div class="col-md-6" >
                <div class="row">
                    <!-- <div class="col-md-5 d-flex justify-content-end ">
                        <img src="./assets/images/logo-ust.jpg" alt="logo" class="img-fluid" style="height:125px!important; color: #fff;" />
                    </div>
                    <div class="col-md-7 d-flex justify-content-start">
                        <img src="./assets/images/sello-gratuidadipcft-2023.png" alt="" class="img-fluid" style="height: 80px; ">                        
                    </div> -->
                    <div class="col-md-7 d-flex ">
                        <img src="./assets/images/logo-ust-gratuidad-2023.svg" alt="logo" class="img-fluid" style="height: 125px!important; float: left;margin-left:3% ">                        
                    </div>
                    <div class="col-md-7 d-flex justify-content-start">                       
                    </div>
                </div>
                <div class="row d-flex  mt-4 ">
                    <img src="./assets/images/imagen-home-matricula-online-ust-2024.jpg" alt="" class="img-fluid" style="margin-left:5%">
                </div>
            </div>
            <div class="col-md-6">
                <div class="row">
                    <div class="card mx-auto cardingreso" style="background-color:#eee; border-color:#114B43; border-top-left-radius: 20px; border-top-right-radius: 20px; height: 700px; margin-top: 150px;">
                        <div class="card-header" style="background: #1cc778; border-top-left-radius: 20px; border-top-right-radius: 20px;">
                            <h3 class="text-center" style="color: #fefefd">¡Bienvenid@ a la UST!,</h3>
                            <h4 class="text-center" style="color: #fefefd;">Realiza tu matrícula 100% online</h4>
                        </div>
                        <div class="card-body mt-1">
                            <label style="font-style: 10px;">Los campos con (*) son obligatorios</label><br>
                            <label class="font-weight-bold">Correo electrónico *</label>
                            <input type="text" class="mt-2 form-control form-control-sm" placeholder="Ingrese correo electrónico" formControlName="Usuario">
                            <span class="text-muted" *ngIf="!LoginForm.controls['Usuario'].valid && LoginForm.controls['Usuario']?.touched">Por
                favor, ingrese un email válido<br></span>

                            <label style="font-style: 10px;">Correo electrónico con el que te creaste la cuenta en Matrícula Online.</label><br>
                            <label class="font-weight-bold">Contraseñas *</label>
                            <input type="password" class="mt-2 form-control form-control-sm mt2" placeholder="Ingrese contraseña" formControlName="Clave">
                            <span class="text-muted" *ngIf="!LoginForm.controls['Clave'].valid && LoginForm.controls['Clave']?.touched">Por
                favor, ingrese un clave válida</span>
                            <label style="font-style: 10px;">La que definiste al crear tu cuenta</label>
                            <div class="row container mt-2">
                                <div class="col-md-12">
                                    <re-captcha (resolved)="resolved($event)" siteKey="6LcvntYZAAAAAD7vJSrZr18NQr-anQiVSDFWRRWd" formControlName="Captcha">
                                    </re-captcha>
                                    <span class="text-muted" *ngIf="!LoginForm.controls['Captcha'].valid && LoginForm.controls['Captcha']?.touched">Debe
                    verificar el captcha</span>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-6">
                                    <button class="btn btn-primary btn-block mt-3 bg-dark ambiente" [disabled]="" (click)="Autenticar()">
                    Ingresar
                  </button>
                                </div>
                                <div class="col-md-6">
                                    <div class="text-center mt-2">
                                        <div class="row">
                                            <label>¿No recuerdas tus datos de acceso?</label>
                                        </div>
                                        <div class="row">
                                            <u>
                        <a class="mt-1" href="/email" style="cursor:pointer; color: #114B43;">
                          Recuperar correo electrónico</a>
                        </u>
                                        </div>
                                        <div class="row">
                                            <u>
                        <a class="mt-1" href="/solicitar" style="cursor:pointer; color: #114B43;">
                          Recuperar la contrase&#241;a</a>
                        </u>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <hr>
                            <h3 class="font-weight-bold">¿No tienes una cuenta?</h3>
                            <label>Para matricularte en linea debes crearte una cuenta con tus datos personales</label>
                            <a class="btn btn-block mb-3 mt-2 ambiente" href="/preregistrar" style="color: white; cursor:pointer;">Crear cuenta</a>
                            <div class="progress" id="progress" *ngIf="progress">
                                <div class="progress-bar progress-bar-striped progress-bar-animated bg-success" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100" style="width: 100%"></div>
                            </div>
                            <div class="alert alert-success alert-dismissible fade show mt-2 lg-success" role="alert" *ngIf="alertSucces">
                                <strong>Autenticado!</strong> En breve será redireccionado.
                                <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
                            </div>
                            <div class="alert alert-warning alert-dismissible fade show mt-2 lg-warning" role="alert" *ngIf="alertError">
                                <strong>Advertencia!</strong> Las credenciales proporcionadas no son válidas.
                                <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
                            </div>
                            <div class="alert alert-warning alert-dismissible fade show mt-2 lg-warning" role="alert" *ngIf="alertErrorBloqueado">
                                <strong>Advertencia!</strong>
                                <p class="text-left">Estimado(a) estudiante,</p>
                                <p class="text-left">
                                    Nuestros sistemas indican que usted tiene bloqueado el acceso al portal. Te agradeceríamos tomar contacto con el área académica de la sede de interés para profundizar la situación.
                                </p>
                                <p class="text-left">
                                    Si necesitas información de contacto de nuestras Sedes, podrás obtenerla en
                                    <a href="http://www.santotomas.cl/contactossedes.html" class="text-primary">http://www.santotomas.cl/contactossedes.html</a>
                                </p>
                                <p class="text-left">
                                    Atentamente, <br /> Dirección de Admisión, Santo Tomás.
                                </p>
                                <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
                            </div>
                            <div class="alert alert-warning alert-dismissible fade show mt-2 lg-warning" role="alert" *ngIf="alertBloqueoFinanciero">
                                <strong>Advertencia!</strong> Estimado(a) estudiante, Nuestros sistemas indican que existe una situación financiera que es necesaria aclarar y, eventualmente pagar o pactar, para poder realizar una nueva matrícula. Te agradeceríamos
                                tomar contacto con el área financiera de la sede en la que estudiaste anteriormente para profundizar la situación.

                                <p class="text-left">
                                    Si necesitas información de contacto de nuestras Sedes, podrás obtenerla en
                                    <a href="http://www.santotomas.cl/contactossedes.html" class="text-primary">http://www.santotomas.cl/contactossedes.html</a>
                                </p>

                                Atentamente, Dirección de Admisión, Santo Tomás.
                                <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
                            </div>
                            <div class="alert alert-danger alert-dismissible fade show mt-2 lg-warning" role="alert" *ngIf="alertFail">
                                <strong>Advertencia!</strong> no se puede conectar al servicio de autenticación.
                                <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>


</form>
<footer style="background: #bfd0c0;" class="mt-2">

    <div class="container">
        <div class="text-center">
            <img src="./assets/images/footer/sello-ust_Mesa_de_trabajo_2022.svg" alt="" class="flogo img-fluid mt-3 mb-2" style="border-left:none; max-height: 60px;">
        </div>

    </div>
    <div class="row" style="height: 30px; background-color:#003b30" class="text-center">
        <p style="color: white; font-family: Roboto,sans-serif;" class="pt-2 mb-2">Derechos reservados Santo Tomás. Casa Central AV. Ejército 146, Barrio Universitario, Santiago.</p>
    </div>
</footer>
